import { IAppWithRoute, ReactApplicationManager } from "@core-ui/react-core";
import buildinFeatures from "@/features/index";
import allProviders from "./providers/index";
import { App } from "./App";
import { router } from "./appRoute";
import { disabledStrictMode } from "@core-ui/react-mobx-state"

// if ('serviceWorker' in navigator) {
//   window.addEventListener('load', () => {
//     navigator.serviceWorker.register('/service-worker.js').then(
//       registration => {
//         console.log('Service Worker registered with scope:', registration.scope);
//       },
//       error => {
//         console.log('Service Worker registration failed:', error);
//       }
//     );
//   });
// }

let reactApp = ReactApplicationManager.getInstance({
  rootId: "root",
  providers: [],
  strictMode: false,
  router: router,
} as unknown as IAppWithRoute);

// App feature area
if (buildinFeatures) {
  buildinFeatures.forEach(
    (
      feat: (appManager: ReactApplicationManager) => ReactApplicationManager,
    ) => {
      reactApp = feat(reactApp);
    },
  );
}

// App providers area (A provider is a HOC component, which wrapped your application main components (all of your router))
reactApp.addProviders(allProviders || []);
reactApp.addProvider(App);

// Render your app into root element here!
disabledStrictMode();
reactApp.start();